module.exports = __webpack_public_path__ + "static/16-sunrise-on-water-2e1b876703825b932c53fe3d0510a3e9.png";